import { t } from "@/core/i18n";

const API_URL = "/v1.0/management/Imports/schools";

const MODULE_TITLE = t("import-schools");

const NAME = "ImportSchools";

export default {
  API_URL,
  NAME,
  MODULE_TITLE,
};
